import { PayloadAction } from '../../../store.model';
import {
    getSelectedFocusFromRows,
    makePerformerRows,
} from '../focus-history/focus-history.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';

import { FocusSelectorSelectClosedForPerformerRow } from './closed-for-performer-select.action';

export function focusSelectorSelectClosedForPerformerRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectClosedForPerformerRow>,
): FocusSelectorState {
    const { rowId } = action.payload;

    const updatedRows = makePerformerRows(
        state.recentlyClosedFocusesForPerformer,
        rowId,
    );

    const selection = getSelectedFocusFromRows(updatedRows);

    return {
        ...state,
        recentlyClosedFocusesPerformerGrid: {
            ...state.recentlyClosedFocusesPerformerGrid,
            rows: updatedRows,
            sortDefs: [...state.recentlyClosedFocusesPerformerGrid.sortDefs],
            selection,
        },
    };
}
